import React, {useState, useEffect} from 'react'
import './loaderlist.scss'

const LoaderList = () => {
	
	const [LoaderData, setLoaderData] = useState ([]);
	
	const getAllLoaderData = async () => {
		try {
			const response = await fetch ('/data/uielements.json');
			if (!response.ok) {
				throw new Error ('Failed to fetch data');
			}
			const data = await response.json ();
			const filterLoaderData = data.UIElements?.filter ((uicode) => uicode.UIElementId === "UIElemetLoader");
			setLoaderData (filterLoaderData || []);
		} catch (err) {
			console.error ('Error fetching loader data:', err);
		}
	}
	
	useEffect (() => {
		getAllLoaderData ();
	}, []);
	
	const handleDownload = (file) => {
		const link = document.createElement ('a');
		link.href = file;
		link.download = file.split ('/').pop (); // Extract file name from path
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	};
	
	const handlePayAmount = (filePay) =>{
		const link = document.createElement ('a');
		link.href = filePay;
		link.download = filePay.split ('/').pop ();;
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	}
	
	return (
		<div className="mainLoaderList">
			<div className="subLoaderList">
				{
					LoaderData.length === 0 ? (
						<p>No Data</p>
					) : (
						LoaderData.map ((item, index) => (
							<div className="LoaderList" key={index}>
								<div className="LoaderListUIElements-image-box">
									<img src={item.VideoGif} alt=""/>
								</div>
								<div className="LoaderListInfo">
									<div className="title">{item.title}</div>
									<p>{item.Developer}</p>
									<div className="mainDownloadBtn">
										{
											item.PayAmount === "Yes" ?(
												<>
													<button onClick={() => handlePayAmount(item.PayAmountUrl)}>Pay</button>
												</>
											): (
												<button className='DownloadBtn' onClick={() => handleDownload (item.ZipFile)}>Download</button>
											)
										}

									</div>
								</div>
							</div>
						))
					)
				}
			</div>
		</div>
	)
}
export default LoaderList
